import { useFormik } from 'formik'
import React, { useEffect } from 'react'
import PageWithCard from '../../components/infrastructure/PageWithCard'
import FormikInputGroup from '../../components/formik/FormikInputGroup'
import { ClipLoader } from 'react-spinners'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton'
import {
  fetchCategories,
  getCategories,
  createCategory,
  deleteCategory
} from '../../app/reducers/Category/categorySlice'
import { Trash } from 'react-feather'
import TableWithHeadingAndGlobalSearch from '../../components/Table/TableWithHeadingAndGlobalSearch'
import { useCallback } from 'react'
import { useMemo } from 'react'

const CreateCategory = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCategories())
  }, [])
  const { loading, category } = useSelector(getCategories)

  const columns = [
    {
      Header: 'SRNO',
      Cell: (prop) => {
        const { data, row } = prop
        return row.index + 1
      },
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Action',
      Cell: (prop) => {
        const { data, row } = prop
        return (
          <div
            className='flex items-center gap-2'
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Trash
              color='red'
              onClick={async () => {
                await dispatch(deleteCategory({ id: row.original._id }))
                dispatch(fetchCategories())
              }}
            />
          </div>
        )
      },
    },
  ]

  const debouncedSearch = useCallback(
    _.debounce((search) => {
      dispatch(fetchCategories({ search: search }))
    }, 300),
    []
  )
  const data = useMemo(
    () => (category?.docs ? category.docs : []),
    [category]
  )

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required(),
    }),
    onSubmit: async (values, { resetForm }) => {
      await dispatch(createCategory({ ...values }))
      dispatch(fetchCategories())
      resetForm()
    },
  })

  return (
    <PageWithCard heading='Ctaegory'>
      <div className='text-slate-800 font-semibold mb-4'>Category Names</div>
      {loading ? (
        <ClipLoader />
      ) : (
      <form onSubmit={formik.handleSubmit} className='flex flex-col gap-4'>
        <FormikInputGroup label='Name' formik={formik} name='name' required />
        <div>
          <PrimaryButton type='submit'>Submit</PrimaryButton>
        </div>
      </form>
      )}
      <TableWithHeadingAndGlobalSearch
        heading='Categories'
        data={data}
        columns={columns}
        loading={loading}
        searchFunction={(value) => {
          debouncedSearch(value)
        }}
      />
    </PageWithCard>
  )
}
export default CreateCategory
